import { get, post } from '../http/request.js'
import request from '../http/http.js'

export const api1 = p1 => post('/api/cms/nav', p1)
export const submited = p1 => post('/api/cms/message', p1)
export const options = p1 => get('/addons/cms/ajax/selectpage.html?id=25&admin=1', p1)
export const news = p1 => post('/api/cms/arclist', p1)
export const content = p1 => post('/api/cms/archives', p1)
export const prevNext = p1 => post('/api/cms/getprevnext', p1)
export const channel = p1 => post('/api/cms/channel', p1)
export const get_block = p => post('/api/cms/block',p)
export const get_num = p => post('/api/cms/views',p)
export const get_good = p => post('/api/cms/vote',p)
export const hot_type = p => post('/api/cms/hotType',p)

// export function api1(data){
//   return request({
//     url: '/api/cms/nav',
//     method: 'post',
//     data
//   })
// }
// export function submited(data){
//   return request({
//     url: '/api/cms/message',
//     method: 'post',
//     data
//   })
// }
// export function options(){
//   return request({
//     url: '/addons/cms/ajax/selectpage.html?id=25&admin=1',
//     method: 'get'
//   })
// }
// export function news(data){
//   return request({
//     url: '/api/cms/arclist',
//     method: 'post',
//     data
//   })
// }
// export function content(data){
//   return request({
//     url: '/api/cms/archives',
//     method: 'post',
//     data
//   })
// }
// export function prevNext(data){
//   return request({
//     url: '/api/cms/getprevnext',
//     method: 'post',
//     data
//   })
// }
// export function channel(data){
//   return request({
//     url: '/api/cms/channel',
//     method: 'post',
//     data
//   })
// }
// export function get_block(data){
//   return request({
//     url: '/api/cms/block',
//     method: 'post',
//     data
//   })
// }
// export function get_num(data){
//   return request({
//     url: '/api/cms/views',
//     method: 'post',
//     data
//   })
// }
// export function get_good(data){
//   return request({
//     url: '/api/cms/vote',
//     method: 'post',
//     data
//   })
// }



// WEBPACK FOOTER //
// ./src/api/index.js